export enum EIoTProviders {
  Kisi = 'kisi',
  MS_SQL = 'ms_sql',
  RHOMBUS = 'rhombus',
  TWINMAKER = 'twinmaker',
  TANKLOGIX = 'tanklogix',
  THINGWORX = 'thingworx'
}

export type TIoTGroup = {
  providerId?: number;
  description?: string;
  id: number | string;
  name: string;
  placeId?: number;
};

export type TIoTDevice = {
  favorite: boolean;
  isFavourite?: boolean;
  groupId: null;
  id: number;
  lockedDown: boolean;
  name: string;
  order: number;
  externalDeviceId: string;
  toursVsImageId: null;
  typeId: number;
  unlocked: false;
  providerId: number;
  measureName?: string;
  measureUnit?: string;
  tagSid?: string;
  tourId: number;
  relatedAssets: null | { [key: string]: string | number }[];
  relatedMeasureUnit: null | { [key: string]: string | number };
  videoUrl?: string;
  value?: string;
  measureUnitId?: number | null;
  additionalInfo?: Record<string, any>;
};

export type TIoTDeviceType = {
  id: number;
  name: string;
};

export type TIoTWebhook = {
  doorName?: string;
  doorAction?: string;
  doorId?: number;
  tourIds?: [number];
  toursVsImageId?: number;
  userName?: string;
  text?: string;
  seen?: boolean;
};

export type TIoTProvider = {
  id: number;
  endpoint: string;
  name: EIoTProviders;
  hasPassCode: boolean;
  providerId?: number;
  icon: string;
  credentials?: string;
  isActive: boolean;
  tourId?: number;
  provider?: {
    id?: number;
    name?: string;
    endpoint?: string;
  };
};
